import { http } from '@/utils/http' // eslint-disable-line
import { getLSItemSafe } from '@/utils/common'
import * as User from '@/utils/user'
import router from '@/router'
import store from '@/store'

const AUTH_TOKEN = 'auth_token'
const ST_TOKEN = 'st_token'
const EXPIRE_AT = 'auth_token_expiration'

const roleRedirectRule = {
  'codes': { 'Verifier': '/completed-transactions' },
  'completed-transactions': { 'Verifier': '/pending-transactions' },
  'pending-transactions': { },
  'settings': { },
}

export function doLogin ({ email, password }) {
  return new Promise((resolve, reject) => {
    http.main.post('/auth/login/', { username: email, password }).then((res) => {
      if (!res.data.token) return reject(new Error('No token received'))
      let expiresAt = JSON.stringify(24 * 60 * 60 * 1000 + new Date().getTime())
      localStorage.setItem(AUTH_TOKEN, res.data.token)
      localStorage.setItem(EXPIRE_AT, expiresAt)
      resolve(res.data.token)
    }).catch((err) => {
      reject(err)
    })
  })
}

export function setSTToken (token) {
  localStorage.setItem(ST_TOKEN, token)
}

export function clearLocalStorage () {
  localStorage.removeItem(AUTH_TOKEN)
  localStorage.removeItem(EXPIRE_AT)
  localStorage.removeItem(ST_TOKEN)
}

export function doLogout () {
  clearLocalStorage()
  router.replace('/login')
}

export function doSTLogout () {
  setSTToken('')
  router.replace('/settings')
}

export function authenticated () {
  // Check whether the current time is past the
  // access token's expiry time
  let expiresAt = JSON.parse(getLSItemSafe(EXPIRE_AT))
  return new Date().getTime() < expiresAt
}

export function isLoggedIn () {
  const token = getAuthToken()
  return !!token && authenticated()
}

export function requireAuth (to, from, next) {
  if (!isLoggedIn()) {
    next('/login')
  } else {
    if (!store.getters.profile || !store.getters.profile.role) {
      const authToken = getAuthToken()
      http.main.setAuthToken(authToken)
      store.dispatch('setAuthToken', authToken)
      store.dispatch('getUserProfile').then(() => {
        next()
      })
    } else {
      next()
    }
  }
}

export function requireSTToken (to, from, next) {
  const stToken = getSTToken()
  if (!stToken) return next('/settings')
  http.st.setAuthToken(stToken)
  store.dispatch('settings/setSettings', { stToken }, { locally: true })
  next()
}

// returns redirect path or undefined
export function getNecessaryRedirectPath (section) {
  const roleTitle = User.getTitle(store.getters['profile'].role)
  return (roleRedirectRule[section] || {})[roleTitle]
}

export function requireSectionRights (section) {
  return function (to, from, next) {
    next(getNecessaryRedirectPath(section))
  }
}

export function getSTToken () {
  return getLSItemSafe(ST_TOKEN)
}

export function getAuthToken () {
  return getLSItemSafe(AUTH_TOKEN)
}

export function getUserProfile () {
  return new Promise((resolve, reject) => {
    http.main.get('/auth/me/').then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}

export function getSTUserProfile (token) {
  return new Promise((resolve, reject) => {
    http.st.get('/auth/me/', { token }).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}


